import $ from 'jquery';

function HelpBubbleAccessibilityHandler(selector) {
  $(selector).on('keypress', '.js-help-bubble', function (e) {
    if (e.keyCode === 32 || e.keyCode === 13) {
      e.preventDefault();
      $(this).trigger('click');
    }
  });
}

export default HelpBubbleAccessibilityHandler;
